module.exports = __webpack_public_path__ + "media/images/icon_baseinfo_address-ac57ba29b80552063277557c190a1eb3.png";